import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { saveLanguagePreference } from "../i18n";
import { trackLanguageChange, trackNavigation } from "../utils/analytics";

export const Navigation = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const changeLanguage = (lng) => {
    // Track language change
    trackLanguageChange(i18n.language, lng);
    
    // Save language preference
    saveLanguagePreference(lng);
    // Меняем URL на новый язык
    navigate(`/${lng}${location.hash}`, { replace: false });
    setIsDropdownOpen(false);
  };

  const handleNavClick = (sectionName) => {
    trackNavigation(sectionName);
  };

  const getLanguageName = (lng) => {
    const names = {
      es: 'Español',
      en: 'English',
      de: 'Deutsch',
      fr: 'Français',
      ru: 'Русский',
      uk: 'Українська',
      ar: 'العربية',
      nl: 'Nederlands',
      it: 'Italiano',
      ro: 'Română',
      pl: 'Polski'
    };
    return names[lng] || lng.toUpperCase();
  };

  const getCurrentLanguageFlag = () => {
    const flags = {
      es: '🇪🇸',
      en: '🇬🇧',
      de: '🇩🇪',
      fr: '🇫🇷',
      ru: '🇷🇺',
      uk: '🇺🇦',
      ar: '🇲🇦',
      nl: '🇳🇱',
      it: '🇮🇹',
      ro: '🇷🇴',
      pl: '🇵🇱'
    };
    return flags[i18n.language] || '🌐';
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top" style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/img/logo.png" alt="OnBuild" style={{ height: '40px', marginRight: '10px' }} />
            <span>{t('nav.brand')}</span>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#how-it-works" className="page-scroll" onClick={() => handleNavClick('how-it-works')}>
                {t('nav.howItWorks')}
              </a>
            </li>
            <li>
              <a href="#benefits" className="page-scroll" onClick={() => handleNavClick('benefits')}>
                {t('nav.benefits')}
              </a>
            </li>
            <li>
              <a href="#signup" className="page-scroll" onClick={() => handleNavClick('signup')}>
                {t('nav.signup')}
              </a>
            </li>
            <li className="dropdown language-dropdown">
              <button
                className="lang-dropdown-btn"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)}
              >
                <span className="flag-icon">{getCurrentLanguageFlag()}</span>
                <span className="lang-text">{getLanguageName(i18n.language)}</span>
                <i className={`fa fa-chevron-down ${isDropdownOpen ? 'open' : ''}`}></i>
              </button>
              {isDropdownOpen && (
                <ul className="lang-dropdown-menu">
                  <li><button onClick={() => changeLanguage('es')}>🇪🇸 Español</button></li>
                  <li><button onClick={() => changeLanguage('en')}>🇬🇧 English</button></li>
                  <li><button onClick={() => changeLanguage('de')}>🇩🇪 Deutsch</button></li>
                  <li><button onClick={() => changeLanguage('fr')}>🇫🇷 Français</button></li>
                  <li><button onClick={() => changeLanguage('ru')}>🇷🇺 Русский</button></li>
                  <li><button onClick={() => changeLanguage('uk')}>🇺🇦 Українська</button></li>
                  <li><button onClick={() => changeLanguage('ar')}>🇲🇦 العربية</button></li>
                  <li><button onClick={() => changeLanguage('nl')}>🇳🇱 Nederlands</button></li>
                  <li><button onClick={() => changeLanguage('it')}>🇮🇹 Italiano</button></li>
                  <li><button onClick={() => changeLanguage('ro')}>🇷🇴 Română</button></li>
                  <li><button onClick={() => changeLanguage('pl')}>🇵🇱 Polski</button></li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
